const InvestmentActionTypes = {
  FETCH_INVESTMENTS_START: "FETCH_ADMIN_INVESTMENTS_START",
  FETCH_INVESTMENTS_SUCCESS: "FETCH_ADMIN_INVESTMENTS_SUCCESS",
  FETCH_INVESTMENTS_FAILURE: "FETCH_ADMIN_INVESTMENTS_FAILURE",

  SET_TOTAL_INVESTMENTS: "SET_TOTAL_INVESTMENTS"
};

export default InvestmentActionTypes;
